import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { ProgressSpinner } from 'primereact/progressspinner';
import { InputNumber } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';


import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { useScreenAds, useUpdateAdsDuration } from '../../../../queries';
import { setAdsSettings, setMediaDelayDuration } from '../../../../redux/Slices/layoutSlice';
import { useCustomToast } from '../../../Contexts/ToastContext';

function AnimationDurations() {
    const { t } = useTranslation();
    const updateAdsDuration = useUpdateAdsDuration()
    const loading = updateAdsDuration.isLoading
    const { adsSettings, media_delay_duration } = useSelector((state) => state.layout);
    const { id } = useParams();
    const dispatch = useDispatch()

    const [editDuration, setEditDuration] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState("");
    const [send, setSend] = useState(false);
    const [changingField, setChangingField] = useState(null);

    const sendOnkeypress = (e) => {
        setEditDuration(false)
        setSend(true)
    }

    const editDurationHandle = () => {
        setEditDuration(true)
    }

    useEffect(() => {
        if (send) {
            updateAdsSettings()
        }
        setSend(false)
    }, [send])

    const updateAdsSettings = async (fieldName) => {
        setChangingField(fieldName);
        try {
            await updateAdsDuration.mutateAsync({
                id: id,
                data: {
                    "ads_settings": adsSettings,
                }
            }, {
                onSuccess: () => {
                    setEditDuration(false);
                }
            });
        } finally {
            setChangingField(null);
        }
    }

    return (
        <>
            {/* adsSettings.ads_delay_duration */}
            <div className=" flex d-flex align-items-center gap-3 ">
                <div className="w-75">
                    <label className="font-large text-sm w-75">
                        {t('animated_layouts.delay_between_rounds')}
                        <i
                            className=" ads_delay_duration pi pi-question-circle text-sm cursor-pointer ml-2"
                        />
                    </label>
                    <Tooltip target=".ads_delay_duration" content={t('animated_layouts.delay_between_rounds_tooltip')} position='top' className="fs-8" hideDelay={100} />
                </div>
                {loading && changingField === 'ads_delay_duration' ? (
                    <ProgressSpinner
                        style={{ width: '30px', height: '30px' }}
                        strokeWidth="3"
                        fill="var(--surface-ground)"
                        animationDuration="2s"
                    />
                ) : (
                    <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                        <InputNumber
                            value={adsSettings.ads_delay_duration}
                            onValueChange={(e) =>
                                dispatch(setAdsSettings({ ads_delay_duration: e.value }))
                            }
                            // onKeyDown={(e) => e.key === 'Enter' && sendOnkeypress(e)}
                            min={1}
                            max={86399}
                            className="p-inputtext-sm h-[35px]  "
                            inputClassName=" w-[35%]"
                            mode="decimal"
                            showButtons={false}
                        />
                        <Tooltip
                            target=".save_duration-ads_delay_duration"
                            content={t('animated_layouts.save_changes')}
                            position="bottom"
                            className="fs-8"
                        />
                        {/* <i
                            className="col-1 mx-2 fas fa-check-circle text-lighter   cursor-pointer save_duration-ads_delay_duration"
                            onClick={() => updateAdsSettings('ads_delay_duration')}
                        ></i> */}
                    </div>
                )}
            </div>

            {/* adsSettings.media_delay_duration */}
            {/* <div className=" flex d-flex align-items-center gap-3 ">
                <div className="w-75">
                    <label className="font-large text-sm">
                         Delay between media items (s)
                        <i
                            className=" media_delay_duration pi pi-question-circle text-sm cursor-pointer ml-2"
                        />
                    </label>
                    <Tooltip target=".media_delay_duration" content="Time between displaying each media in a round" position='top' className="fs-8" hideDelay={100} />
                </div>
                {loading && changingField === 'media_delay_duration' ? (
                    <ProgressSpinner
                        style={{ width: '30px', height: '30px' }}
                        strokeWidth="3"
                        fill="var(--surface-ground)"
                        animationDuration="2s"
                    />
                ) : (
                    <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                        <InputNumber
                            value={media_delay_duration}
                            onValueChange={(e) =>
                                dispatch(setMediaDelayDuration(e.value))
                            }
                             min={0}
                            max={100}
                            className="p-inputtext-sm  h-[35px] "
                            inputClassName=" w-[35%]"
                            mode="decimal"
                            showButtons={false}
                        />
                      
                    </div>
                )}
            </div> */}

            {/* adsSettings.ads_repetition_count */}
            <div className=" flex d-flex align-items-center gap-3">
                <div className="w-75">
                    <label className="font-large text-sm">
                        {t('animated_layouts.repetition_count')}
                        <i
                            className=" ads_repetition_count pi pi-question-circle text-sm cursor-pointer ml-2"
                        />
                    </label>
                    <Tooltip target=".ads_repetition_count" content={t('animated_layouts.repetition_count_tooltip')} position='top' className="fs-8" hideDelay={100} />
                </div>
                {loading && changingField === 'ads_repetition_count' ? (
                    <ProgressSpinner
                        style={{ width: '30px', height: '30px' }}
                        strokeWidth="3"
                        fill="var(--surface-ground)"
                        animationDuration="2s"
                    />
                ) : (
                    <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                        <InputNumber
                            value={adsSettings.ads_repetition_count}
                            onValueChange={(e) =>
                                dispatch(setAdsSettings({ ads_repetition_count: e.value }))
                            }
                            // onKeyDown={(e) => e.key === 'Enter' && sendOnkeypress(e)}
                            min={1}
                            max={100}
                            className="p-inputtext-sm h-[35px] "
                            inputClassName=" w-[35%]"
                            mode="decimal"
                            showButtons={false}
                        />
                        <Tooltip
                            target=".save_duration-ads_repetition_count"
                            content={t('animated_layouts.save_changes')}
                            position="bottom"
                            className="fs-8"
                        />
                        {/* <i
                            className="col-1 mx-2 fas fa-check-circle text-lighter   cursor-pointer save_duration-ads_repetition_count"
                            onClick={() => updateAdsSettings('ads_repetition_count')}
                        ></i> */}
                    </div>
                )}
            </div>





            {/* adsSettings.animation_duration */}
            < div className=" flex d-flex align-items-center gap-3 " >
                <div className="w-75">
                    <label className="font-large text-sm   ">
                        {t('animated_layouts.animation_speed')}
                        <i
                            className=" speed pi pi-question-circle text-sm cursor-pointer ml-2"
                        />
                    </label>
                    <Tooltip target=".speed" content={t('animated_layouts.animation_speed_tooltip')} position='top' className="fs-8" hideDelay={100} />

                </div>
                {
                    loading && changingField === 'animation_duration' ? (
                        <ProgressSpinner
                            style={{ width: '30px', height: '30px' }}
                            strokeWidth="3"
                            fill="var(--surface-ground)"
                            animationDuration="2s"
                        />
                    ) : (
                        <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                            <InputNumber
                                value={adsSettings.animation_duration}
                                onValueChange={(e) =>
                                    dispatch(setAdsSettings({ animation_duration: e.value }))
                                }
                                // onKeyDown={(e) => e.key === 'Enter' && sendOnkeypress(e)}
                                min={1}
                                max={100}
                                className="p-inputtext-sm  h-[35px] "
                                inputClassName=" w-[35%]"
                                mode="decimal"
                                showButtons={false}
                            />
                            <Tooltip
                                target=".save_duration-animation_duration"
                                content={t('animated_layouts.save_changes')}
                                position="bottom"
                                className="fs-8"
                            />
                            {/* <i
                                className="col-1 mx-2 fas fa-check-circle text-lighter   cursor-pointer save_duration-animation_duration"
                                onClick={() => updateAdsSettings('animation_duration')}
                            ></i> */}
                        </div>
                    )
                }
            </div >

        </>
    )
}

const ScreenMediaDuration = () => {
    const { t } = useTranslation();
    const { isAdScreen, isAnimationScreen, screenDetails, media_delay_duration } = useSelector((state) => state.layout);
    const openDialog = useSelector((state) => state.global.openDialog);

    const { showToast } = useCustomToast();
    const dispatch = useDispatch()

    const { mutate: enableAds, isLoading: enabling } = useScreenAds();





    const adsDurationHandler = (key) => {
        enableAds({
            id: screenDetails.id,
            data: {
                "is_Ad_Screen_Enabled": key,
                "media_delay_duration": media_delay_duration,

            }
        }, {
            onSuccess: () => {
                showToast('success', t('animated_layouts.toast_layout_updating'), t('animated_layouts.toast_media_delay_success'));
            }
        })
    }


    return (
        <>

            <div className='bg-[#f8f6fb] rounded-lg'>

                {/* media_delay_duration */}
                <div className=" flex d-flex align-items-center ">
                    <div className="w-75">
                        <label className="font-large text-l">
                            {t('animated_layouts.media_delay_duration')}
                            <i
                                className=" media_delay_duration pi pi-question-circle text-sm cursor-pointer ml-2"
                            />
                        </label>
                        <Tooltip target=".media_delay_duration" content={t('animated_layouts.media_delay_duration_tooltip')} position='top' className="fs-8" hideDelay={100} />
                    </div>
                    {enabling ? (
                        <ProgressSpinner
                            style={{ width: '30px', height: '30px' }}
                            strokeWidth="3"
                            fill="var(--surface-ground)"
                            animationDuration="2s"
                        />
                    ) : (
                        <div className="d-flex w-25 m-1 justify-content-end align-items-center">
                            <InputNumber
                                value={media_delay_duration}
                                onValueChange={(e) =>
                                    dispatch(setMediaDelayDuration(e.value))
                                }
                                onKeyDown={(e) => e.key === 'Enter' && dispatch(setMediaDelayDuration(e.value))
                                }
                                min={0}
                                max={100}
                                className="p-inputtext-sm  h-[30px] "
                                inputClassName=" w-[35%]"
                                mode="decimal"
                                showButtons={false}
                            />
                            <Tooltip
                                target=".save_duration-media_delay_duration"
                                content={t('animated_layouts.save_changes')}
                                position="bottom"
                                className="fs-8"
                            />
                            <i
                                className="col-1 mx-2 fas fa-check-circle text-lighter   cursor-pointer save_duration-media_delay_duration"
                                onClick={() => adsDurationHandler(true)}
                            ></i>
                        </div>
                    )}
                </div>
            </div>




        </>
    );
};

export { AnimationDurations, ScreenMediaDuration };